import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { isMobile } from '@/utils/device';
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n.js';
import appConfig from '@/common/config.js';

if (isMobile()) {
  Vue.use(Vant);
} else {
  Vue.use(ElementUI);
}

Vue.prototype.$isMobile = isMobile;
Vue.prototype.$appConfig = appConfig;



Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
